import Resource from './Resource';

/**
 * Contact Resource
 */
class Contact extends Resource
{
    constructor() {
        super('contact', ['contacts']);
    }

    options(params) {
        return this._doGet(['options'], params);
    }
    search(query, type = null, params = {}, config = {}) {
      params = Object.assign(params, { query });

      if (type) {
          params.type = type;
      }

      return this._doGet(['search'], params, config);
    }

    validate(data) {
        return this._doPost(['validates'], data, {});
    }

    merge(id, target_id) {
      return this._doPost([id, 'merge'], { contact_id: target_id }, {});
    }

    possibleDuplicates(id) {
      return this._doGet([id, 'possible-duplicates'])
    }

    relatedVehicles(id) {
      return this._doGet([id, 'related-vehicles'])
    }

    stream(id) {
        return this._doGet([id, 'stream']);
    }

    relinkXeroContact(id, xeroContactId) {
        return this._doPut([id, 'xero-reference'], { xero_contact_id: xeroContactId });
    }
}

export let ContactResource = new Contact();

/**
 * ReferralSource Resource
 */
class ReferralSource extends Resource
{
    constructor() {
        super('referral.source', ['referral-sources']);
    }
}   

export let ReferralSourceResource = new ReferralSource();

/**
 * [ContactSchema description]
 * @param {[type]} defaults [description]
 */
export let ContactSchema  = function(defaults = null) {
   let schema = {
      "title": "",
      "first_name": "",
      "last_name": "",
      "company_name": "",
      "file_as": "",
      "type": "",
      "primary_telephone": "",
      "alternate_telephone": "",
      "email": "",
      "vat_registration_number": "",
      "address_1": "",
      "address_2": "",
      "address_3": "",
      "town": "",
      "county": "",
      "post_code": "",
      "country": "",
      "referral_source_id": null,
      "referral_source": {},
      "id": "",
      "created_by_id": "",
      "created_at": "",
      "updated_at": "",
      "primary_display_as": "",
      "secondary_display_as": "",
      "avatar_url": "",
      "telephone_marketing": false,
      "email_marketing": false,
      "sms_marketing": false,
      "default_expense_account_id": null,
      "default_expense_account": {},
      "default_expense_tax_rate": null,
      activity: [],
   };

   if (defaults) {
      schema = Object.assign(schema, defaults);
   }

   return schema;
};

export let ContactTypes = {
    RECORD: 'record',
    LEAD: 'lead',
    CUSTOMER: 'customer',
    TRADE_CUSTOMER: 'trade_customer',
    FINANCE_PROVIDER: 'finance_provider',
    SUPPLIER: 'supplier',
    OTHER: 'other',
};

/**
 * [ContactTypeList description]
 * @type {Array}
 */
export let ContactTypeList = [
    { value: ContactTypes.LEAD, label: 'Lead' },
    { value: ContactTypes.CUSTOMER, label: 'Customer' },
    { value: ContactTypes.TRADE_CUSTOMER, label: 'Trade Customer' },
    { value: ContactTypes.FINANCE_PROVIDER, label: 'Finance Provider' },
    { value: ContactTypes.SUPPLIER, label: 'Supplier' },
    { value: ContactTypes.OTHER, label: 'Other' },
];
/**
 * [ContactTitles description]
 * @type {Array}
 */
export let ContactTitles = [
    { value: '', label: 'None' },
    { value: 'Mr', label: 'Mr' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Miss', label: 'Miss' },
    { value: 'Dr', label: 'Dr' },
    { value: 'Prof', label: 'Prof' },
    { value: 'Sir', label: 'Sir' },
    { value: 'Lady', label: 'Lady' },
];

export default Contact;